import { jsx as _jsx } from "react/jsx-runtime";
import { useState } from "react";
import { TextInput } from "../../../components/Inputs";
import { useTranslations } from "../../../providers/useTranslations";
import { formatDate } from "../../../utils/formatDate/formatDate";
import EditIcon from "../../../icons/edit.svg";
import { DatePicker } from "../DatePicker";
import styles from "./DatePickerInput.module.scss";
export const DatePickerInput = ({ currentlyBookedDate, onDateSelect, ...restProps }) => {
    const { __ } = useTranslations();
    const [isOpen, setIsOpen] = useState(false);
    const initialValue = formatDate(currentlyBookedDate) || __("profile.subscription.editBilling.select_day");
    const [inputValue, setInputValue] = useState(initialValue);
    const handleInputClick = () => {
        setIsOpen((prevIsOpen) => !prevIsOpen);
    };
    const handleSaveSelection = (selectedDate) => {
        if (!selectedDate) {
            return;
        }
        setInputValue(formatDate(selectedDate));
        setIsOpen(false);
        onDateSelect?.(selectedDate);
    };
    return (_jsx("div", { ...restProps, children: isOpen ? (_jsx("div", { className: styles.calendarBox, children: _jsx(DatePicker, { onSaveSelection: handleSaveSelection, ...(currentlyBookedDate ? { currentlyBookedDate } : {}) }) })) : (_jsx("div", { className: styles.inputBox, onClick: handleInputClick, role: "button", "aria-label": __("profile.subscription.editBilling.title"), children: _jsx(TextInput, { className: styles.input, placeholder: inputValue, type: "text", dataTestId: "datePickerInput", iconRight: EditIcon }) })) }));
};
//# sourceMappingURL=DatePickerInput.js.map